export const getId = (o: Record<string, unknown>) => o?.id ?? o?._id;
